import { message } from 'antd';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { fetchHL7QueueAPI } from '../../../services/hl7-queue-service';
import { FETCH_HL7_QUEUE, FETCH_HL7_QUEUE_ERROR, FETCH_HL7_QUEUE_START, FETCH_HL7_QUEUE_SUCCESS } from '../../actions/admin/hl7QueueAction';


function* fetchHL7Queue({ payload }) {
    try {
        yield put({ type: FETCH_HL7_QUEUE_START })
        const response = yield call(fetchHL7QueueAPI, payload);
        if (response.success) {

            const data = {
                pagination: {
                    currentPage: payload.page,
                    pageSize: payload.size,
                    totalPages: response.data.totalPages,
                    totalItems: response.data.totalItems,
                },
                hl7Queue: [...response.data.hl7QueueMessageList]
            }
            yield put({ type: FETCH_HL7_QUEUE_SUCCESS, data })
        } else {

            if (response.error) {
                yield put({ type: FETCH_HL7_QUEUE_ERROR });
                message.error(response.error);
            } else {
                yield put({ type: FETCH_HL7_QUEUE_ERROR });
                message.error('Failed to fetch HL7 queue!');
            }
        }
    } catch (error) {
        yield put({ type: FETCH_HL7_QUEUE_ERROR, error })
        message.error('Failed to fetch HL7 queue!');
    }
}

function* hl7QueueWatcher() {
    yield takeEvery(FETCH_HL7_QUEUE, fetchHL7Queue)
}

export default function* rootSaga() {
    yield all([
        hl7QueueWatcher()
    ]);
}